import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { satusList } from '../../GSConstants'
import { focusElemnt, isEmpty, navigation1 } from '../../../../common/helper'
import * as mdt from '../../../../common/modaltypes'
import { updateAutoDelivery } from '../../../../../store/generalSetting/GSAction'
import { updateAlertError } from '../../../../../store/common/common_action'
import { connect } from 'react-redux'
import Lineinput from '../../../../common/lineinput'

const AutoDeliveryModal = (props) => {
  const {
    data: { common },
    updateAlertError,
    updateAutoDelivery,
  } = props
  const { loginData, branchConfiguration } = common
  const { getTableData, branchList, userList, cityList, updateModal, headTxt, isUpdate, editData } = props
  const [selDays, setSelDays] = useState({ id: 0, label: `0 days` })
  const [selHours, setSelHours] = useState({ id: 0, label: `0 Hours` })
  const [selMinutes, setSelMinutes] = useState({ id: 0, label: `0 Minutes` })
  const [selBranch, setSelBranch] = useState()
  const [selUser, setSelUser] = useState()
  const [selCity, setSelCity] = useState()
  const [isActive, setIsActive] = useState({ id: 1, name: 'Active' })
  const [checkboxStatus, setCheckboxStatus] = useState({
    Paid: false,
    PaidManual: false,
    ToPay: false,
    ToPayManual: false,
    ToPayDDDV: false,
    OnAccount: false,
    OnAccountManual: false,
    COD: false,
    SelfBooking: false,
    FOC: false,
  })
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const dropStyle = {
    zIndex: '1',
    position: 'absolute',
    top: '-210px',
    left: '0',
  }
  const columnDefs = [
    {
      headerName: 'Select',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '2%' },
      field: 'select',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: 'Payment Type',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '12%' },
      field: 'paymentType',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: 'Del. Hamali',
      headerSx: { padding: '6px 12px', textAlign: 'right', minWidth: '10%' },
      field: 'delHamali',
      dataType: 'number',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: 'Extra Hamali',
      headerSx: { padding: '6px 12px', textAlign: 'right', minWidth: '10%' },
      field: 'extraHamali',
      dataType: 'number',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: 'Demurrage',
      headerSx: { padding: '6px 12px', textAlign: 'right', minWidth: '10%' },
      field: 'demurrage',
      dataType: 'number',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: 'Del. Cartage',
      headerSx: { padding: '6px 12px', textAlign: 'right', minWidth: '15%' },
      field: 'delCartage',
      dataType: 'number',
      showfilter: true,
      allowSorting: false,
    },
  ]
  const paymentTable = [
    {
      select: false,
      paymentType: 'Paid',
      delHamali: editData?.PaidDelHamali || 0,
      extraHamali: editData?.PaidExtHamali || 0,
      demurrage: editData?.PaidDemurrage || 0,
      delCartage: editData?.PaidCartage || 0,
    },
    {
      select: false,
      paymentType: 'Paid Manual',
      delHamali: editData?.PaidManDelHamali || 0,
      extraHamali: editData?.PaidManExtHamali || 0,
      demurrage: editData?.PaidManDemurrage || 0,
      delCartage: editData?.PaidManCartage || 0,
    },
    {
      select: false,
      paymentType: 'ToPay',
      delHamali: editData?.TopayDelHamali || 0,
      extraHamali: editData?.TopayExtHamali || 0,
      demurrage: editData?.TopayDemurrage || 0,
      delCartage: editData?.TopayCartage || 0,
    },
    {
      select: false,
      paymentType: 'ToPay Manual',
      delHamali: editData?.TopayManDelHamali || 0,
      extraHamali: editData?.TopayManExtHamali || 0,
      demurrage: editData?.TopayManDemurrage || 0,
      delCartage: editData?.TopayManCartage || 0,
    },
    {
      select: false,
      paymentType: 'ToPay DDDV',
      delHamali: editData?.DDDVDelHamali || 0,
      extraHamali: editData?.DDDVExtHamali || 0,
      demurrage: editData?.DDDVDemurrage || 0,
      delCartage: editData?.DDDVCartage || 0,
    },
    {
      select: false,
      paymentType: 'OnAccount',
      delHamali: editData?.OnAccDelHamali || 0,
      extraHamali: editData?.OnAccExtHamali || 0,
      demurrage: editData?.OnAccDemurrage || 0,
      delCartage: editData?.OnAccCartage || 0,
    },

    {
      select: false,
      paymentType: 'OnAccount Manual',
      delHamali: editData?.OnaccManDelHam || 0,
      extraHamali: editData?.OnaccManExtHam || 0,
      demurrage: editData?.OnaccManDem || 0,
      delCartage: editData?.OnaccManCartage || 0,
    },
    {
      select: false,
      paymentType: 'COD',
      delHamali: editData?.CODDelHamali || 0,
      extraHamali: editData?.CODExtHamali || 0,
      demurrage: editData?.CODDemurrage || 0,
      delCartage: editData?.CODCartage || 0,
    },
    {
      select: false,
      paymentType: 'Self Booking',
      delHamali: editData?.SelfDelHam || 0,
      extraHamali: editData?.SelfExtHam || 0,
      demurrage: editData?.SelfDem || 0,
      delCartage: editData?.SelfCartage || 0,
    },
    {
      select: false,
      paymentType: 'FOC',
      delHamali: editData?.FOCDelHamali || 0,
      extraHamali: editData?.FOCExtHamali || 0,
      demurrage: editData?.FOCDemurrage || 0,
      delCartage: editData?.FOCCartage || 0,
    },
  ]
  const handleCheckboxChange = (paymentType, checked) => {
    setCheckboxStatus((prevState) => ({
      ...prevState,
      [paymentType]: checked,
    }))
  }
  const [editableData, setEditableData] = useState([...paymentTable])
  const handleChange = (index, key, value, id) => {
    const newData = [...editableData]
    newData[index][key] = value
    setEditableData(newData)
    setTimeout(() => {
      focusElemnt(id)
    }, 10)
  }
  useEffect(() => {
    focusElemnt('selAutoDelByCity')
  }, [])

  useEffect(() => {
    if (isUpdate) {
      setSelDays({ id: editData?.Days, label: `${editData?.Days} days` })
      setSelHours({ id: editData?.Hours, label: `${editData?.Hours} Hours` })
      setSelMinutes({ id: editData?.Minutes, label: `${editData?.Minutes} Minutes` })
      setSelBranch({ BranchID: editData?.BranchID, BranchName: editData?.BranchName })
      setSelUser({ UserID: editData?.UserID, UserName: editData?.UserName })
      setSelCity({ CityID: editData?.CityID, CityName: editData?.CityName })
      setIsActive({ id: editData?.IsActive, name: editData?.IsActive ? 'Active' : 'Deactive' })
    }
  }, [isUpdate])

  const AutoTransRecvRow = (props) => {
    const { item, index } = props
    let isInputDisable =
      branchConfiguration?.RecDelOtpAll || (index === 5 && branchConfiguration?.RecDelOtpOnAcc) || !checkboxStatus[item.paymentType]
    let isCheckBoxDisable = branchConfiguration?.RecDelOtpAll || (index === 5 && branchConfiguration?.RecDelOtpOnAcc)
    return (
      <TableRow key={`auto-del-${index}`} style={{ minHeight: '36px' }}>
        <TableCell
          style={{ textAlign: '-webkit-center', fontSize: '12px', minHeight: '36px', color: '#444444', width: '2%', padding: '0px 8px' }}
        >
          <Item className="checkbox-ctrl" style={{ padding: '0px 8px', backgroundColor: 'transparent' }}>
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  id={`chkbox-${index}`}
                  checked={checkboxStatus[item.paymentType]}
                  onChange={(e) => handleCheckboxChange(item.paymentType, e.target.checked)}
                  disabled={isCheckBoxDisable}
                  sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                  onKeyDown={(e) => {
                    navigation1(e, `delHamali-${index}`, `selAutoDelAftMin`)
                  }}
                />
              }
              labelPlacement="end"
            />
          </Item>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '12%', padding: '0px 8px' }}>
          {item.paymentType}
        </TableCell>
        <TableCell style={{ textAlign: 'right', fontSize: '12px', minHeight: '36px', color: '#444444', width: '10%', padding: '0px 8px' }}>
          <div className="filter-input" style={{ fontSize: '12px' }}>
            <input
              id={`delHamali-${index}`}
              className="field"
              name="cancelSearchInput"
              value={item.delHamali}
              onChange={(e) => handleChange(index, 'delHamali', e.target.value, `delHamali-${index}`)}
              disabled={isInputDisable}
              style={{
                width: '100%',
                paddingTop: '5px',
                textAlign: 'right',
                backgroundColor: isInputDisable ? 'lightGray' : '',
              }}
              onKeyDown={(e) => {
                navigation1(e, `extHamali-${index}`, `chkbox-${index}`)
              }}
            />
          </div>
        </TableCell>
        <TableCell style={{ textAlign: 'right', fontSize: '12px', minHeight: '36px', color: '#444444', width: '10%', padding: '0px 8px' }}>
          <div className="filter-input" style={{ fontSize: '12px' }}>
            <input
              id={`extHamali-${index}`}
              className="field"
              name="cancelSearchInput"
              value={item.extraHamali}
              onChange={(e) => handleChange(index, 'extraHamali', e.target.value, `extHamali-${index}`)}
              disabled={isInputDisable}
              style={{
                width: '100%',
                paddingTop: '5px',
                textAlign: 'right',
                backgroundColor: isInputDisable ? 'lightGray' : '',
              }}
              onKeyDown={(e) => {
                navigation1(e, `demHamali-${index}`, `delHamali-${index}`)
              }}
            />
          </div>
        </TableCell>
        <TableCell style={{ textAlign: 'right', fontSize: '12px', minHeight: '36px', color: '#444444', width: '10%', padding: '0px 8px' }}>
          <div className="filter-input" style={{ fontSize: '12px' }}>
            <input
              id={`demHamali-${index}`}
              className="field"
              name="cancelSearchInput"
              value={item.demurrage}
              onChange={(e) => handleChange(index, 'demurrage', e.target.value, `demHamali-${index}`)}
              disabled={isInputDisable}
              style={{
                width: '100%',
                paddingTop: '5px',
                textAlign: 'right',
                backgroundColor: isInputDisable ? 'lightGray' : '',
              }}
              onKeyDown={(e) => {
                navigation1(e, `delCartHamali-${index}`, `extHamali-${index}`)
              }}
            />
          </div>
        </TableCell>
        <TableCell style={{ textAlign: 'right', fontSize: '12px', minHeight: '36px', color: '#444444', width: '10%', padding: '0px 8px' }}>
          <div className="filter-input" style={{ fontSize: '12px' }}>
            <input
              id={`delCartHamali-${index}`}
              className="field"
              name="cancelSearchInput"
              value={item.delCartage}
              onChange={(e) => handleChange(index, 'delCartage', e.target.value, `delCartHamali-${index}`)}
              disabled={isInputDisable}
              style={{
                width: '100%',
                paddingTop: '5px',
                textAlign: 'right',
                backgroundColor: isInputDisable ? 'lightGray' : '',
              }}
              onKeyDown={(e) => {
                navigation1(e, `chkbox-${index + 1}`, `demHamali-${index}`)
              }}
            />
          </div>
        </TableCell>
      </TableRow>
    )
  }
  // Generate options for days
  const daysOptions = Array.from({ length: 8 }, (_, index) => ({
    id: index,
    label: `${index} days`,
  }))
  // Generate options for Hours
  const hrsOptions = Array.from({ length: 24 }, (_, index) => ({
    id: index,
    label: `${index} Hours`,
  }))
  // Generate options for Minutes
  const minOptions = Array.from({ length: 60 }, (_, index) => ({
    id: index,
    label: `${index} Minutes`,
  }))
  const handleSaveAutoDelivery = () => {
    const totalMinutes = selDays?.id * 24 * 60 + selHours?.id * 60 + selMinutes?.id
    const body = {
      BranchID: selBranch?.BranchID,
      AutoDeliveryUserID: selUser?.UserID,
      IsActive: isActive?.id,
      PaidDelHam: parseInt(editableData[0].delHamali),
      TopayDelHam: parseInt(editableData[2].delHamali),
      OnAccDelHam: parseInt(editableData[5].delHamali),
      PaidManDelHam: parseInt(editableData[1].delHamali),
      TopayManDelHam: parseInt(editableData[3].delHamali),
      FOCDelHam: parseInt(editableData[9].delHamali),
      CODDelHam: parseInt(editableData[7].delHamali),
      DDDVDelHam: parseInt(editableData[4].delHamali),
      PaidCartage: parseInt(editableData[0].delCartage),
      TopayCartage: parseInt(editableData[2].delCartage),
      OnAccCartage: parseInt(editableData[5].delCartage),
      PaidManCartage: parseInt(editableData[1].delCartage),
      TopayManCartage: parseInt(editableData[3].delCartage),
      FOCCartage: parseInt(editableData[9].delCartage),
      CODCartage: parseInt(editableData[7].delCartage),
      DDDVCartage: parseInt(editableData[4].delCartage),
      PaidDem: parseInt(editableData[0].demurrage),
      TopayDem: parseInt(editableData[2].demurrage),
      OnAccDem: parseInt(editableData[5].demurrage),
      PaidManDem: parseInt(editableData[1].demurrage),
      TopayManDem: parseInt(editableData[3].demurrage),
      FOCDem: parseInt(editableData[9].demurrage),
      CODDem: parseInt(editableData[7].demurrage),
      DDDVDem: parseInt(editableData[4].demurrage),
      PaidExtHam: parseInt(editableData[0].extraHamali),
      TopayExtHam: parseInt(editableData[2].extraHamali),
      OnAccExtHam: parseInt(editableData[5].extraHamali),
      PaidManExtHam: parseInt(editableData[1].extraHamali),
      TopayManExtHam: parseInt(editableData[3].extraHamali),
      FOCExtHam: parseInt(editableData[9].extraHamali),
      CODExtHam: parseInt(editableData[7].extraHamali),
      DDDVExtHam: parseInt(editableData[4].extraHamali),
      SelfDelHam: parseInt(editableData[8].delHamali),
      SelfCartage: parseInt(editableData[8].delCartage),
      SelfDem: parseInt(editableData[8].demurrage),
      SelfExtHam: parseInt(editableData[8].extraHamali),
      OnaccManDelHam: parseInt(editableData[6].delHamali),
      OnaccManCartage: parseInt(editableData[6].delCartage),
      OnaccManDem: parseInt(editableData[6].demurrage),
      OnaccManExtHam: parseInt(editableData[6].extraHamali),
      ModifiedByUser: loginData?.intUserID,
      Minutes: totalMinutes,
    }
    updateAutoDelivery(body)
      .then((res) => {
        if (res.status === 'Success') {
          isUpdate ? updateModal(false, mdt.AutoDeliveryEdit) : updateModal(false, mdt.AutoDeliveryCreate)
          getTableData()
          updateModal(true, mdt.autoDeliveryConfModal)
          // getDemurrageChrgList()
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
        }
      })
      .catch((err) => {
        console.log('Error:', err)
      })
  }
  return (
    <Modal
      headTxt={headTxt}
      width={'45%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Grid container sx={{ padding: '10px 8px 10px 8px' }}>
        <Grid item md={6}>
          <Grid container rowSpacing={1}>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id={'selAutoDelByCity'}
                  label={'Select Auto Delivery By City'}
                  width="100%"
                  nextId={'selAutoDelByBranch'}
                  defaultvalue={selCity?.CityName}
                  data={cityList}
                  idKey={`CityID`}
                  dataKey={`CityName`}
                  onSelResetVal={true}
                  onSelect={(val) => {
                    setSelCity(val)
                  }}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id={'selAutoDelByBranch'}
                  data={branchList?.filter((val) => val.CityID == selCity?.CityID)}
                  dataKey={`BranchName`}
                  idKey={`BranchID`}
                  label={'Select Auto Delivery By Branch'}
                  width="100%"
                  defaultvalue={selBranch?.BranchName}
                  onSelect={(val) => {
                    setSelBranch(val)
                  }}
                  nextId={'selAutoDelByUser'}
                  prevId={'selAutoDelByCity'}
                  onSelResetVal={true}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id={'selAutoDelByUser'}
                  // data={userList}
                  data={userList?.filter((val) => val.BranchID == selBranch?.BranchID)}
                  dataKey={`UserName`}
                  idKey={`UserID`}
                  label={'Select Auto Delivery By User'}
                  width="100%"
                  defaultvalue={selUser?.UserName}
                  onSelect={(val) => {
                    setSelUser(val)
                  }}
                  nextId={'selAutoDelAftDays'}
                  prevId={'selAutoDelByBranch'}
                  // onSelResetVal={true}
                  // resetFlag={reset?.fromUser}
                />
              </Item>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6}>
          <Grid container rowSpacing={1}>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  data={daysOptions}
                  id={'selAutoDelAftDays'}
                  label={'Select Auto Delivery After Days'}
                  width="100%"
                  idKey={`id`}
                  dataKey={`label`}
                  nextId={'selAutoDelAftHours'}
                  prevId={'selAutoDelByUser'}
                  defaultvalue={selDays?.label}
                  onSelect={(val) => {
                    setSelDays(val)
                  }}
                  calendarIcon={true}
                  onSelResetVal={true}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id={'selAutoDelAftHours'}
                  label={'Select Auto Delivery After Hours'}
                  width="100%"
                  style={{ marginLeft: 'auto' }}
                  data={hrsOptions}
                  idKey={`id`}
                  dataKey={`label`}
                  defaultvalue={selHours?.label}
                  onSelect={(val) => {
                    setSelHours(val)
                  }}
                  nextId={'selAutoDelAftMin'}
                  prevId={'selAutoDelAftDays'}
                  watchIcon={true}
                  onSelResetVal={true}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id={'selAutoDelAftMin'}
                  label={'Select Auto Delivery After Minutes'}
                  width="100%"
                  style={{ marginLeft: 'auto' }}
                  data={minOptions}
                  idKey={`id`}
                  dataKey={`label`}
                  defaultvalue={selMinutes?.label}
                  onSelect={(val) => {
                    setSelMinutes(val)
                  }}
                  prevId={'selAutoDelAftHours'}
                  nextId={`chkbox-${0}`}
                  watchIcon={true}
                  onSelResetVal={true}
                />
              </Item>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Stack style={{ maxHeight: '60vh', paddingLeft: '16px', paddingRight: '16px' }}>
        <TableContainer
          className="lr-popup-table lrModel  scrollBlue"
          style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }}
          component={Paper}
        >
          <Table
            style={{ border: 'none', overflow: 'auto' }}
            stickyHeader
            id="focApprovalTbl"
            className="table1 table-Received "
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff', height: '36px' }}>
                {columnDefs.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '36px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      {col.headerName.split('\n').map((line, lineIndex) => (
                        <span key={`line-${lineIndex}`} style={{}}>
                          {line}
                        </span>
                      ))}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody className="filter-data-row" style={{ border: 'none' }}>
              {editableData?.map((item, index) => (
                <AutoTransRecvRow item={item} index={index} key={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ display: 'flex', padding: '12px 0px' }}>
          <DropDownOA
            // sx={{ ...sx.itemsx, paddingX: '12px' }}
            data={satusList}
            id={'status'}
            label={'Status'}
            width="318px"
            idKey={`id`}
            dataKey={`name`}
            defaultvalue={isActive?.name}
            onSelect={(val) => {
              setIsActive(val)
            }}
            isError={isActive.id == 0}
            isSuccess={isActive.id == 1}
            dropStyle={dropStyle}
          />
          <Button
            className="cancel-btn"
            variant="outlined"
            color="error"
            style={{ height: '40px', color: '#fe5200', fontSize: 'medium', marginLeft: 'auto', marginRight: '12px' }}
            onClick={() => {
              isUpdate ? updateModal(false, mdt.AutoDeliveryEdit) : updateModal(false, mdt.AutoDeliveryCreate)
            }}
          >
            Cancel
          </Button>
          <Button
            id="mopAddBtn"
            style={{ margin: '0', height: '40px' }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={handleSaveAutoDelivery}
            // onKeyDown={(e) => {
            //     navigation1(e, `editBtn-0`, 'mopActive');
            // }}
          >
            {isUpdate ? 'Update' : 'Save'}
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateAlertError,
  updateAutoDelivery,
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoDeliveryModal)
